<template>
	<div class="container-custom">
		<div class="step step--how text-center">
			<carousel ref="carouselHowToUse" :per-page="1" :mouse-drag="true" :speed="600">
			<slide class="w-100">
				<figure class="how-img how-img--1 mx-auto p-4 mb-0">
				<img alt="Iqos Pocket" src="@/assets/how/1.png" />
				</figure>
				<div class="how-det px-2 intro">
				<p
					class="align-self-center w-100 m-0"
				>Pentru înțelegerea și memorarea instrucțiunilor, adu-ți kit-ul IQOS lângă telefon și replică mișcările după sau în timpul fiecărui video în parte.</p>
				</div>

				<button
				class="btn btn--primary btn--lg mb-2 mt-5"
				@click="slideControl('next')"
				type="button"
				>Next</button>
				<br />
				<router-link :to="{name: 'chose-device'}" class="btn text-underline">
				<u>Skip</u>
				</router-link>
			</slide>
			<slide class="w-100">
				<figure class="how-img how-img--2 mx-auto p-4 mb-0">
				<img class="img-fluid" alt="Iqos Pocket" src="@/assets/how/2.png" />
				</figure>
				<div class="how-det px-2 intro">
				<p
					class="align-self-center w-100 m-0 px-5"
				>Alege apoi din meniul dedicat dispozitivul despre care vrei să afli mai multe.</p>
				</div>
				<button
				class="btn btn--primary btn--lg mb-2 mt-5"
				@click="slideControl('next')"
				type="button"
				>Next</button>
				<br />
				<router-link :to="{name: 'chose-device'}" class="btn text-underline">
				<u>Skip</u>
				</router-link>
			</slide>
			<slide class="w-100">
				<figure class="how-img how-img--3 mx-auto mb-0">
				<img alt="Iqos Pocket" src="@/assets/icon-howto3.png" />
				</figure>
				<div class="how-det px-2 intro mb-5">
				<p class="align-self-center w-100 m-0 px-4">
					Pune pauză sau întoarce-te la
					o secvență anterioară din cadrul video-ului tău pentru a surprinde orice detaliu de folosire.
				</p>
				</div>
				<router-link
				:to="{name: 'chose-device'}"
				class="btn btn--primary btn--lg mt-5"
				>Folosește IQOS POCKET</router-link>
			</slide>
			</carousel>
		</div>
	</div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
	name: "HowToUse",
	components: {
		Carousel,
		Slide
	},
	autoplay: true,
	methods: {
		
		slideControl (action) {
			let page = 0
			if (action === 'next') {
				page = this.$refs.carouselHowToUse.getNextPage()
			} else {
				page = this.$refs.carouselHowToUse.getPreviousPage()
			}
			this.$refs.carouselHowToUse.goToPage(page)
		}
	}
};
</script>
